// -----------------------------
// * imagingOrderForm.js *
// -----------------------------

goog.provide('el8.appchart.dialog.order.imaging');

goog.require('el8.appchart.dialog.order.base');
goog.require('el8.data.practiceUsers');
goog.require('el8.ptdata.model.order');
goog.require('el8.service.infoField');
goog.require('el8.service.tz');
goog.require('el8.uiwidget.base');
goog.require('el8.util.dom');

el8.appchart.dialog.order.imaging = function() {

    // Oh shit... This is a pre-closure template!!!
    var container = $('#new-imaging-order-dialog');
    var formContainer = $('#new-imaging-order-form');

    // --------------------
    // Get form fields
    // --------------------
    var testCenterNotesTextarea = container.find(':input[name="testCenterNotes"]');
    var clinicalReasonTextarea = container.find(':input[name="clinicalReason"]');

    var dateForTestInputField = container.find(':input[name="dateForTest"]');
    var followUpMethodInputField = container.find(':input[name="followUpMethod"]');

    var testCenterCompanySelectField = container.find(':input[name="testCenterCompany"]');
    var testCenterSiteSelectField = container.find(':input[name="testCenterSite"]');

    var faxPrelimCheckbox = container.find(':input[name="faxPrelim"]');

    var isPatientPregnantCheckbox = container.find(':input[name="isPatientPregnant"]');
    var routineChannelsCheckbox = container.find(':input[name="routineChannels"]');
    var patientBackWithFilmsCheckbox = container.find(':input[name="patientBackWithFilms"]');
    var patientHomeIfNegativeCheckbox = container.find(':input[name="patientHomeIfNegative"]');

    // --------------------
    // Initialize form fields
    // --------------------
    var dateForTestField = dateForTestInputField.el8_datePicker({},
        { infoText: 'do test on...' }
    );

    var followUpMethodField = el8.service.infoField.addInfoField({
        field : followUpMethodInputField,
        maxLength : 50,
        height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
        infoText : 'how to notify patient of results...'
    });

    var testCenterNotesField = el8.service.infoField.addInfoField({
        field: testCenterNotesTextarea,
        height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
        infoText: 'notes to test center..'
    });

    var clinicalReasonField = el8.service.infoField.addInfoField({
        field: clinicalReasonTextarea,
        height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
        infoText: 'write clinical reason...'
    });

    if (el8Globals.FEATURES.BiDiLabs) {
        var reminderUserOrGroupField = el8.service.infoField.addInfoField({
            name: 'reminderUserOrGroup',
            field: container.find('.reminder-user-or-group')
        });

        var reminderDateInputField = container.find(':input[name="reminderDate"]');
        var reminderDateField = reminderDateInputField.el8_datePicker(
            {minDate: el8.service.tz.today()},
            { infoText: 'no reminder' }
        );

    }

    // ------------------------------
    // Get/extract order object from form ()
    // ------------------------------
    function getOrder( model, isOnHold ) {

        var testCenterCompanyId = 1 * testCenterCompanySelectField.val();
        var testCenterSiteId = 1 * testCenterSiteSelectField.val();

        var dateForTest = dateForTestField.noInput() ? null : dateForTestField.getVal();

        var testCenterNotes = testCenterNotesField.getVal();
        var followUpMethod = followUpMethodField.getVal();
        var clinicalReason = clinicalReasonField.getVal();

        that.setPrescribingUser(model);
        model.setOnHold( isOnHold );
        model.setTestCenterCompanyId( testCenterCompanyId );
        model.setTestCenterSiteId( testCenterSiteId );

        model.setDateForTest( dateForTest );

        model.setTestCenterNotes( testCenterNotes );
        model.setFollowUpMethod( followUpMethod );
        model.setClinicalReason( clinicalReason );

        that.extractCcs(model, ccsWidget);
        that.extractTests(model, testsWidget);
        that.extractDiagnoses(model, dxWidget);

        var statMethod = container.find('input:radio[name="statMethod"]:checked').val();
        model.setStatMethod( statMethod );

        that.extractConfidentiality(model);
        that.extractShowDualCoding(model);

        // Reminders
        if (el8Globals.FEATURES.BiDiLabs) {
            that.extractReminderUserOrGroupId(model);
            model.setReminderDate(reminderDateField.noInput() ? null :  reminderDateField.getVal());
        }

        return model;
    }

    // ------------------------------
    // Populate forms
    // ------------------------------
    function populateForms(model, dialog) {

        dialog.enableForms();

        // Initialize all fields with instructions.
        dateForTestField.init();
        followUpMethodField.init();
        testsField.init();
        ccsField.init();
        testCenterNotesField.init();
        clinicalReasonField.init();

        if (el8Globals.FEATURES.BiDiLabs) {
            reminderUserOrGroupField.init();
            reminderDateField.init();
            $('.reminder-user-or-group', container).empty();
             _.each(el8.data.practiceUsers.getAssignees(), function(obj) {
                $('<option>').val(obj.id).text(obj.name).appendTo($('.reminder-user-or-group', container));
            });
        }

        if( model ) {
            that.populateTestCenter(model);
            that.populateDateForTest(model);

            testCenterNotesField.setVal( model.getTestCenterNotes() );
            clinicalReasonField.setVal( model.getClinicalReason() );
            followUpMethodField.setVal( model.getFollowUpMethod() );

            that.populateCcs(model, ccsWidget);
            that.populateTestNames(model, testsWidget);
            that.populateDiagnoses(model, dxWidget);

            if (el8Globals.FEATURES.BiDiLabs) {
                var reminder = model.getReminder();
                if (reminder) {
                    reminderUserOrGroupField.setVal(reminder.getAssigneeId());
                    reminderDateField.setVal(reminder.getRemindDate().asString());
                }
            }

            that.populateConfidentiality(model);

            // orderFormImaging specifics
            container.find('input:radio[name="statMethod"][value="'+model.getStatMethod()+'"]').prop('checked', true);
        } else {
            // TODO -- These defaults should NOT be hard-coded; however, for now we don't
            // have a good way to programmatically compute which site to select
            if (el8.data.currPractice.getId() === 4915204) { //DF
                that.populateTestCenterFields({'testCenterCompanyId': 1441800,
                                               'testCenterSiteId': 2097158});
            } else if (el8.data.currPractice.getId() === 73395929092) { //DC
                that.populateTestCenterFields({'testCenterCompanyId': 1441800,
                                               'testCenterSiteId': 2097158});
            } else if (el8.data.currPractice.getId() === 68862148612) { //ElationEMR
                that.populateTestCenterFields({'testCenterCompanyId': 49020936,
                                               'testCenterSiteId': null});
            } else {
                that.populateTestCenterFields({'testCenterCompanyId': 103136296968, //Other
                                               'testCenterSiteId': null});
            }
        }
    }

    // Fill these in via ACMSWidget below
    var testsField = null;
    var ccsField = null;

    // --------------------
    // Initialize autocomplete functionality
    // --------------------
    var testsWidget = null;
    var ccsWidget = null;
    var dxWidget = null;


    function initWidgets() {
        var obj = that.initTestNames();
        testsWidget = obj.listeditor;
        testsField = obj.infoField;

        dxWidget = that.initDxs();

        obj = that.initCcsNames();
        ccsWidget = obj.listeditor;
        ccsField = obj.infoField;
    }

    function closeWidgets() {
        testsWidget.reset();
        ccsWidget.reset();
        dxWidget.reset();

        var $reasonField = clinicalReasonField.getInputField();
        el8.util.dom.growShrinkTextarea($reasonField, null, $reasonField.attr('height'));
    }

    function initCheckboxes() {
        faxPrelimCheckbox.change( function() {
            if( $(this).is(':checked') ) {
                testCenterNotesField.setVal(
                    testCenterNotesField.getVal() + ' Fax preliminary report.'
                );
            }
        });
        isPatientPregnantCheckbox.change( function() {
            if( $(this).is(':checked') ) {
                testCenterNotesField.setVal(
                    testCenterNotesField.getVal() + ' Patient is pregnant.'
                );
            }
        });
        routineChannelsCheckbox.change( function() {
            if( $(this).is(':checked') ) {
                testCenterNotesField.setVal(
                    testCenterNotesField.getVal() + ' Routine Channels.'
                );
            }
        });
        patientBackWithFilmsCheckbox.change( function() {
            if( $(this).is(':checked') ) {
                testCenterNotesField.setVal(
                    testCenterNotesField.getVal() + ' Patient back with film.'
                );
            }
        });
        patientHomeIfNegativeCheckbox.change( function() {
            if( $(this).is(':checked') ) {
                testCenterNotesField.setVal(
                    testCenterNotesField.getVal() + ' Patient home if negative.'
                );
            }
        });
    }

    // ------------------------------
    // Initialize dialog and buttons
    // ------------------------------
    var titleHtml = '<div class="headerContainer">Imaging Requisition Form</div>'; // XSS OK -KF

    var that = el8.appchart.dialog.order.base({
        type : 'imaging',
        container : container,
        formContainer : formContainer,
        testCenterCompanySelectField : testCenterCompanySelectField,
        testCenterSiteSelectField : testCenterSiteSelectField,
        getOrderFn : getOrder,
        populateFormsFn : populateForms,
        closeWidgetsFn : closeWidgets,
        titleHtml : titleHtml,
        newModelFn : function newModelFn() {
            return el8.ptdata.model.order.imaging( {
                'model_class' : 'ImagingOrder',
                'isOnHold' : false,
                'documentDate' : el8.service.tz.now()
            });
        },
        dateForTestField : dateForTestField,
        dialogSpec : {
            dialogRightMargin: 575-45,
            dialogBottomMargin: 100
        }
    });

    initWidgets();
    that.initFollowUpMethod(followUpMethodField);
    initCheckboxes();
    // Needs to come last after widgets are initialized
    // so that dialog is initialized with tabOrder including widgets
    that.init();

    return that;

};
